import Model from '@/models/Model'

export default class Avatar extends Model {
  resource() {
    return 'avatar'
  }
}
